import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {ArrowRight, CheckCircle, Shield} from 'lucide-react';
import { motion } from "framer-motion";
import { useAuth } from "../hooks/useAuth";

const Subscription: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, signIn } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const offer = useMemo(
    () => ({
      id: "premium_app_monthly",
      name: "Accès complet Body Titan",
      price: 6.99,
      cadence: "mois",
      highlights: [
      "Nutrition : stratégies simples + bases claires",
      "Plans repas : exemples prêts à suivre",
      "Calculateur calories : homme / femme + ajustements faciles",
      "Programmes et exercices guidés (vidéos démo)",
      "Suivi plus clair : tu sais quoi faire, quand, et pourquoi",
      "Gain de temps : moins d'hésitation, plus d'exécution",
      "Essai gratuit 7 jours • annulable à tout moment"]

    }),
    []
  );

  const FUNCTION_URL = "https://api.lumi.new/v1/functions/p380144077566414848/createCheckoutSession";

  const handleCta = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const toastId = toast.loading("Préparation de l'accès...");

    const payload = {
      planId: offer.id,
      userId: user?.userId || "guest",
      returnUrl: window.location.origin + "/paiement-confirme",
      provider: "stripe"
    };

    console.log("[Subscription] handleCta déclenché");
    console.log("[Subscription] URL appelée :", FUNCTION_URL);
    console.log("[Subscription] Payload envoyé :", JSON.stringify(payload));

    try {
      const response = await fetch(FUNCTION_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      console.log("[Subscription] Statut réponse HTTP :", response.status);

      const data = await response.json();
      console.log("[Subscription] Réponse JSON :", JSON.stringify(data));

      if (data?.url) {
        toast.success("Redirection vers le paiement sécurisé...", { id: toastId });
        const win = window.open();
        if (win) {
          win.location.href = data.url;
        } else {
          window.location.href = data.url;
        }
        return;
      }

      const errMsg = data?.error || "Impossible d'ouvrir le paiement. Réessayez.";
      console.error("[Subscription] Erreur retournée par la fonction :", errMsg);
      toast.error(errMsg, { id: toastId });
    } catch (error: any) {
      console.error("[Subscription] Exception fetch :", error);
      toast.error(error?.message || "Erreur réseau lors de la redirection.", { id: toastId });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 py-10">
      <div className="mx-auto w-full max-w-md px-4">
        <motion.header
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-6">

          <div className="inline-flex items-center gap-2 rounded-full border border-gray-700 bg-gray-800/60 px-3 py-1 text-xs text-gray-300">
            <Shield className="h-4 w-4 text-blue-500" />
            Paiement sécurisé • Accès immédiat
          </div>

          <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-white">
            Accès complet pour un <span className="text-blue-500">physique sérieux</span>
          </h1>
          <p className="mt-2 text-base text-gray-300">Pensé pour homme/femme  : prise de muscle, recomposition, perte de gras. Du concret, sans bullshit.

          </p>
        </motion.header>

        <motion.section
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          className="rounded-2xl border border-gray-700 bg-gray-800/60 p-5 shadow-xl">

          <div className="flex items-start justify-between gap-4">
            <div>
              <h2 className="text-lg font-bold text-white">{offer.name}</h2>
              <p className="mt-1 text-sm text-gray-400">
                Pour ceux qui veulent progresser sans se perdre dans 100 méthodes.
              </p>
            </div>
            <div className="text-right">
              <div className="text-3xl font-extrabold text-white">
                {offer.price.toFixed(2).replace(".", ",")}€
              </div>
              <div className="text-xs text-gray-400">/ {offer.cadence}</div>
            </div>
          </div>

          <ul className="mt-5 space-y-3">
            {offer.highlights.map((text) =>
            <li key={text} className="flex gap-2 text-sm text-gray-200">
                <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-500" />
                <span>{text}</span>
              </li>
            )}
          </ul>

          <button
            onClick={handleCta}
            disabled={isLoading}
            className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-500 px-5 py-4 text-base font-bold text-white shadow-lg shadow-blue-500/20 transition-all hover:from-blue-700 hover:to-blue-600 disabled:cursor-not-allowed disabled:opacity-60">

            {isLoading ? "Chargement..." : "Activer l'accès complet"}
            <ArrowRight className="h-5 w-5" />
          </button>

          <button
            onClick={() => navigate(-1)}
            className="mt-3 w-full rounded-xl border border-gray-700 bg-transparent px-5 py-3 text-sm font-semibold text-gray-300 hover:bg-gray-800">

            Retour
          </button>

          <p className="mt-4 text-center text-xs text-gray-500">
            Paiement sécurisé • Accès immédiat • Essai 7 jours • Annulation à tout moment
          </p>
        </motion.section>
      </div>
    </div>);

};

export default Subscription;